import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BookOpen } from 'lucide-react';
const names = ['María L.', 'Juan P.', 'Laura G.', 'Diego M.', 'Sofía R.', 'Martín T.', 'Ana C.', 'Carlos V.', 'Florencia S.', 'Pablo D.'];
const cities = ['Córdoba', 'Buenos Aires', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén', 'Bahía Blanca', 'San Juan', 'Resistencia', 'Posadas', 'Paraná'];
const products = ['el Pack Completo', 'Salud y Adolescencia 360'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: '',
    product: ''
  });
  useEffect(() => {
    const showNotification = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomProduct = products[Math.floor(Math.random() * products.length)];
      setNotification({
        name: randomName,
        city: randomCity,
        product: randomProduct
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    const initialTimer = setTimeout(showNotification, 3000);
    const interval = setInterval(() => {
      const nextDelay = Math.floor(Math.random() * (12000 - 8000 + 1) + 8000);
      setTimeout(showNotification, nextDelay);
    }, 12000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-137">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-2xl border border-gray-200 p-3 max-w-xs flex items-start gap-3" data-id="element-138">
          <div className="bg-brand-accent/10 p-2 rounded-full flex-shrink-0 border border-brand-accent/20" data-id="element-139">
            <BookOpen className="w-5 h-5 text-brand-accent" data-id="element-140" />
          </div>
          <div data-id="element-141">
            <p className="text-[10px] font-heading font-bold text-gray-500 uppercase tracking-wider mb-0.5" data-id="element-142">
              ALGUIEN ACABA DE COMPRAR
            </p>
            <p className="text-sm font-heading font-bold text-gray-900 leading-tight" data-id="element-143">
              {notification.product}
            </p>
            <p className="text-xs text-gray-600 mt-1 font-body" data-id="element-144">
              {notification.name} de {notification.city}
            </p>
            <p className="text-[10px] text-gray-400 mt-0.5 font-body" data-id="element-145">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}